import { z } from "zod";

export const workerBasicDataSchema = z.object({
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  age: z.number().int().min(18).max(99).optional(),
  gender: z.enum(["female", "male", "other"]).optional(),
});

export const workerCompetenciesSchema = z.object({
  competencies: z
    .array(z.string())
    .min(1, "Select at least 1 competency")
    .max(3, "Select at most 3 competencies"),
  customInstructions: z.string().max(2000).optional(),
});

export const workerPersonalitySchema = z.object({
  tone: z.number().int().min(1).max(10).default(5),
  traits: z.array(z.string()).max(5),
  additionalInstructions: z.string().max(2000).optional(),
  language: z.enum(["pl", "en"]).default("en"),
});

export const workerEmailAvatarSchema = z.object({
  emailLogin: z
    .string()
    .min(10)
    .max(50)
    .regex(
      /^[a-z][a-z0-9.]{9,}$/,
      "Must start with a letter, contain only lowercase letters, numbers, and dots, min 10 chars",
    ),
  emailDomain: z.enum(["pracownik.ai", "teammember.ai"]),
});

export const workerRuntimeSchema = z.object({
  // No .default(): when omitted, the use case applies `DEFAULT_AGENT_RUNTIME`
  // from env. A schema-level default would make that env knob dead code —
  // Zod would always fill "openclaw" here before the use case ran.
  agentRuntime: z.enum(["openclaw", "hermes"]).optional(),
});

export const createWorkerSchema = z.object({
  ...workerBasicDataSchema.shape,
  ...workerCompetenciesSchema.shape,
  ...workerPersonalitySchema.shape,
  ...workerEmailAvatarSchema.shape,
  ...workerRuntimeSchema.shape,
});

export type WorkerBasicDataInput = z.infer<typeof workerBasicDataSchema>;
export type WorkerCompetenciesInput = z.infer<typeof workerCompetenciesSchema>;
export type WorkerPersonalityInput = z.infer<typeof workerPersonalitySchema>;
export type WorkerEmailAvatarInput = z.infer<typeof workerEmailAvatarSchema>;
export type WorkerRuntimeInput = z.infer<typeof workerRuntimeSchema>;
export type CreateWorkerInput = z.infer<typeof createWorkerSchema>;
